import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgServiceDenied3 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 612,
	height: 392,
	viewBox: "0 0 612 392",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "f1503154-f50a-4680-8aa4-587be41cac87",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "e1abf0e4-070b-4c82-8a12-ebedd4e3db02",
				fill: "#e6e6e6",
				stroke: "none",
				d: "M 0.26201 0.315674 L 611.723022 0.315674 L 611.723022 391.922638 L 0.26201 391.922638 Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "ace8bea0-82e8-49b8-a50c-1e1cb532084f",
				fill: "#ffffff",
				stroke: "none",
				d: "M 19.746 49.432678 L 596.237976 49.432678 L 596.237976 368.754639 L 19.746 368.754639 Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "b540f353-e277-4512-bc56-a133cea2858b",
				fill: "#e67300",
				stroke: "none",
				d: "M 0 -0.031311 L 611.460999 -0.031311 L 611.460999 25.945679 L 0 25.945679 Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "b2b285b5-c1c3-4b12-9710-2898c7239781",
				fill: "#ffffff",
				stroke: "none",
				d: "M 24.12001 13.249695 C 24.12001 15.908936 21.964262 18.064697 19.30501 18.064697 C 16.64576 18.064697 14.49001 15.908936 14.49001 13.249695 C 14.49001 10.590393 16.64576 8.434692 19.30501 8.434692 C 21.964262 8.434692 24.12001 10.590393 24.12001 13.249695 Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "a5a428bb-42a2-4f57-9e6c-9979c01a2490",
				fill: "#ffffff",
				stroke: "none",
				d: "M 42.395012 13.249695 C 42.395012 15.908936 40.239262 18.064697 37.580009 18.064697 C 34.920757 18.064697 32.765011 15.908936 32.765011 13.249695 C 32.765011 10.590393 34.920757 8.434692 37.580009 8.434692 C 40.239262 8.434692 42.395012 10.590393 42.395012 13.249695 Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "a9929a25-14ce-4464-bac9-4165f1e3fae6",
				fill: "#ffffff",
				stroke: "none",
				d: "M 60.67001 13.249695 C 60.67001 15.908936 58.514259 18.064697 55.855011 18.064697 C 53.195759 18.064697 51.040009 15.908936 51.040009 13.249695 C 51.040009 10.590393 53.195759 8.434692 55.855011 8.434692 C 58.514259 8.434692 60.67001 10.590393 60.67001 13.249695 Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "b4a2d72b-abc3-4d2f-a2b8-a2aff6897b26-385",
				fill: "#e67300",
				stroke: "none",
				d: "M 120.605011 94.189697 L 82.472015 131.84668 L 120.605011 169.502686 L 129.185028 160.922668 L 100.350037 132.083679 L 129.426025 103.00769 Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "b5120d89-6cbe-4bfa-9a1b-cf9b07deff91-386",
				fill: "#e67300",
				stroke: "none",
				d: "M 151.850037 94.189697 L 189.982025 131.84668 L 151.850037 169.502686 L 143.27002 160.922668 L 172.107025 132.084656 L 143.029022 103.00769 Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "a31271bd-8e2f-469b-8cee-8b6db3f92f99-387",
				fill: "#e6e6e6",
				stroke: "none",
				d: "M 275.194 103.639648 C 272.075012 103.639648 269.546997 105.433655 269.546997 107.645691 C 269.546997 109.857666 272.075012 111.651672 275.194 111.651672 L 541.407959 111.651672 C 544.526978 111.651672 547.054993 109.857666 547.054993 107.645691 C 547.054993 105.433655 544.526978 103.639648 541.407959 103.639648 Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "bf577952-0fd5-43e0-be6b-ea1966b51a93-388",
				fill: "#e6e6e6",
				stroke: "none",
				d: "M 538.760986 323.118683 L 90.923035 323.118683 C 86.345032 323.118683 82.63504 320.475677 82.630035 317.218689 L 82.630035 238.176666 C 82.63504 234.919678 86.345032 232.276672 90.923035 232.276672 L 538.760986 232.276672 C 543.338989 232.276672 547.049011 234.919678 547.054016 238.176666 L 547.054016 317.217682 C 547.049988 320.474701 543.338989 323.114685 538.760986 323.118683 Z M 90.923035 234.634674 C 88.176025 234.634674 85.950043 236.220673 85.947021 238.174683 L 85.947021 317.215668 C 85.947021 319.169678 88.176025 320.753662 90.923035 320.755676 L 538.760986 320.755676 C 541.507996 320.755676 543.734009 319.169678 543.737 317.215668 L 543.737 238.176666 C 543.737 236.222687 541.507996 234.638672 538.760986 234.636688 Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "f7f4957b-eaa8-456b-bf02-bacf7de3ef80",
				fill: "#e6e6e6",
				stroke: "none",
				d: "M 157.076004 277.663666 C 157.076004 288.729248 148.105591 297.699646 137.040009 297.699646 C 125.974434 297.699646 117.004013 288.729248 117.004013 277.663666 C 117.004013 266.598083 125.974434 257.627655 137.040009 257.627655 C 148.105591 257.627655 157.076004 266.598083 157.076004 277.663666 Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "fb0f055d-da6e-47f2-bb6d-7ff26d7b746a-389",
				fill: "#e67300",
				stroke: "none",
				d: "M 193.550018 261.639679 C 191.337585 261.63681 189.541718 263.42804 189.538849 265.640503 C 189.53598 267.852936 191.327209 269.648804 193.539673 269.651672 L 382.41098 269.651672 C 384.623444 269.651672 386.416962 267.858124 386.416962 265.64566 C 386.416962 263.433228 384.623444 261.639679 382.41098 261.639679 Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "bfcde504-8c45-4d21-843b-87b1f7e22ce0-390",
				fill: "#e67300",
				stroke: "none",
				d: "M 193.550018 285.676697 C 191.337585 285.673828 189.541718 287.465057 189.538849 289.677521 C 189.53598 291.889954 191.327209 293.685822 193.539673 293.68869 L 274.81601 293.68869 C 277.028473 293.691559 278.824341 291.90033 278.827209 289.687897 C 278.830078 287.475433 277.038849 285.679565 274.826416 285.676697 L 193.550018 285.676697 Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "a66699ea-75f1-4575-b6d5-52b0b1f8e30c-391",
				fill: "#e6e6e6",
				stroke: "none",
				d: "M 273.250031 127.639648 C 271.162415 127.807983 269.554016 129.55127 269.554016 131.645691 C 269.554016 133.740051 271.162415 135.483337 273.250031 135.651672 L 447.720062 135.651672 C 449.807648 135.483337 451.416046 133.740051 451.416046 131.645691 C 451.416046 129.55127 449.807648 127.807983 447.720062 127.639648 Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "bbc4ca7b-25d4-4c7e-b3d4-0411f69bd48f-392",
				fill: "#e6e6e6",
				stroke: "none",
				d: "M 274.39798 151.639648 C 271.718994 151.639648 269.546997 153.433655 269.546997 155.645691 C 269.546997 157.857666 271.718994 159.651672 274.39798 159.651672 L 503.097992 159.651672 C 505.777008 159.651672 507.949005 157.857666 507.949005 155.645691 C 507.949005 153.433655 505.777008 151.639648 503.097992 151.639648 Z"
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgServiceDenied3);
export default ForwardRef;
